import GrowthAcquisitionEpicClient from 'bundles/epic/clients/GrowthAcquisition';

/**
 * Checks a configuration EPIC to see if a degree is excluded from showing EOI (Expression of Interest) based on its slug.
 */
export const isDegreeExcludedFromShowingEOI = (slug: string) => {
  return GrowthAcquisitionEpicClient.preview('degreesExcludedFromShowingEOI').includes(slug);
};

export default {
  isDegreeExcludedFromShowingEOI,
};
